<template>
<div>
  <div class="numul">
    <ul v-if="bigClass=='LHC'" class="lhcul" >
      <li v-for="(item,index) in drawList" :key="index" class="lhcli" v-show="index+1 != drawList.length && 'true'">
        <span class="ballspan" :class="'sebo-'+findNumbColor(item)">{{item}}</span>
        <br>
        <span class="textspan">{{findNumbAnimal(item,getAnimalList())}}</span>
      </li>
      <li class="addli">+ </li>
      <li class="lhcli tema" v-if="drawList.length>0">
          <span class="ballspan" :class="'sebo-'+findNumbColor(drawList[drawList.length-1])">{{drawList[drawList.length-1]}}</span>
          <br>
          <span class="textspan">{{findNumbAnimal(drawList[drawList.length-1],getAnimalList())}}</span>
      </li>
    </ul>
    <ul v-else :class="types=='home'?'homeul':'lotteryul'" >
      <li v-for="(item,index) in drawList" :key="index" class="blue">{{item}}</li>
    </ul>
  </div>
  <div class="smalltable" v-if="types=='home'">
    <table v-if="bigClass=='LHC'" cellpadding="0" cellspacing="0" border="0" style="width:100%;textAlign:center;border-top: solid 1px #e5e5e5;border-left: solid 1px #e5e5e5;">
      <tr>
        <td style="border-right: solid 1px #e5e5e5;border-bottom: solid 1px #e5e5e5;color:#de0846" height="30">特码单双</td>
        <td style="border-right: solid 1px #e5e5e5;border-bottom: solid 1px #e5e5e5;color:#de0846" height="30">特码大小</td>
        <td style="border-right: solid 1px #e5e5e5;border-bottom: solid 1px #e5e5e5;color:#de0846" height="30">总和单双</td>
        <td style="border-right: solid 1px #e5e5e5;border-bottom: solid 1px #e5e5e5;color:#de0846" height="30">总和大小</td>
      </tr>
      <tr>
        <td style="border-right: solid 1px #e5e5e5;border-bottom: solid 1px #e5e5e5;" height="30" v-for="(item,index) in drawingNumbertool" :key="index">{{item}}</td>
      </tr>
    </table>
    <table v-else cellpadding="0" cellspacing="0" border="0" style="width:100%;textAlign:center;border-top: solid 1px #e5e5e5;border-left: solid 1px #e5e5e5;">
      <tr>
        <td style="border-right: solid 1px #e5e5e5;border-bottom: solid 1px #e5e5e5;color:#de0846" height="30" colspan="3">总和</td>
        <td style="border-right: solid 1px #e5e5e5;border-bottom: solid 1px #e5e5e5;color:#de0846" height="30">龙虎</td>
      </tr>
      <tr>
        <td style="border-right: solid 1px #e5e5e5;border-bottom: solid 1px #e5e5e5;" width="105" height="30" v-for="(item,index) in drawingNumbertool" :key="index">{{item}}</td>
      </tr>
    </table>
  </div>
</div>
</template>

<script>
import lotteryRandBall from "~/mixins/lotteryRandBall.mixins";
import lhcMixins from "~/mixins/lhc.mixins";

export default {
  mixins: [lotteryRandBall, lhcMixins],
  data() {
    return {
    };
  },
  props: {
    lottery: {
      type: [Object],
      default: null
    },
  },
  methods: {
    getAnimalList(periodsNumber) {
      return this.getCurrYearAnimal(this.lottery.periodsNumber.slice(0, 4));
    },
  },
  computed: {
    drawingNumbertool(){
      let { drawingNumber, bigClass } = this;
      if(drawingNumber.length<=1){
        drawingNumber = this.randList;
      }
      if(bigClass == '11X5' || bigClass == 'SSC'){
        let tool = [];
        let add = drawingNumber.reduce((a,b) => a * 1 + b * 1);
        tool.push(add);
        if (add > 22) { tool.push("大") } else { tool.push("小") };
        if (add %2 == 0) { tool.push("双") } else { tool.push("单") };
        if (drawingNumber[0] > drawingNumber[4]) { tool.push("龙") } else { tool.push("虎") };
        return tool
      } else if (bigClass == 'LHC') {
        let tool = [];
        if (drawingNumber[6] %2 == 0) { tool.push("双") } else { tool.push("单") };
        if (drawingNumber[6] > 22) { tool.push("大") } else { tool.push("小") };
        let add = drawingNumber.reduce((a,b) => a * 1 + b * 1);
        if (add %2 == 0) { tool.push("双") } else { tool.push("单") };
        if (add > 174) { tool.push("大") } else { tool.push("小") };
        return tool
      }
    }
  }
};
</script>

<style lang="less" scoped>
.numul {
  display: flex;
  flex-wrap: nowrap;
  margin-top: 16px;
  height: 56px;
  .lhcul{
    display: flex;
    .addli{
      padding-top: 4px;
    }
    .lhcli{
      height: 56px;
      width: 30px;
      margin-right: 8px;
      font-size: 16px;
      font-weight: 500;
      text-align: center;
      span{
        display: inline-block;
        width: 30px;
      }
      .ballspan{
        height: 30px;
        line-height: 30px;
        border-radius: 15px;
      }
      .textspan{
        height: 26px;
        line-height: 26px;
      }
      .sebo-red{
        box-shadow: 0 0px 1px 1px #ff4545, inset 0 0px 1px 1px #ff4545;
      }
      .sebo-blue{
        box-shadow: 0 0px 1px 1px #4ea9ff, inset 0 0px 1px 1px #4ea9ff;
      }
      .sebo-green{
        box-shadow: 0 0px 1px 1px #54ecbf, inset 0 0px 1px 1px #54ecbf;
      }
      &.tema{
        margin-left: 8px;
        .sebo-red{
          background-color: #ff4545;
          color: #fff;
        }
        .sebo-blue{
          background-color: #4ea9ff;
          color: #fff;
        }
        .sebo-green{
          background-color: #54ecbf;
          color: #fff;
        }
      }
    }
  }
  .lotteryul {
    display: flex;
    .blue {
      width: 36px;
      height: 36px;
      line-height: 36px;
      border-radius: 18px;
      color: #fff;
      font-size: 18px;
      font-weight: 600;
      text-align: center;
      background: url(../../assets/xuebitu.png) no-repeat -1px -47px !important;
      margin: 0 10px;
    }
  }
  .homeul {
    display: flex;
    .blue {
      width: 36px;
      height: 36px;
      line-height: 36px;
      border-radius: 18px;
      color: #fff;
      font-size: 18px;
      font-weight: 600;
      text-align: center;
      background: url(../../assets/xuebitu.png) no-repeat -1px -47px !important;
      margin: 0 2px;
    }
  }
}
</style>